import type { MonitoringListSummaryDto } from '@app/api/routes/monitoringLists/dtos'

export const summaryLabelMap: Record<keyof MonitoringListSummaryDto, string> = {
  isTop1: 'TOP1',
  isInfo: 'Info',
  isShortKvi: 'ShortKVI',
  updatedLists: 'Измененных списков',
  summary: 'Исходное количество позиций',
  statusDeleted: 'Удалено',
  statusAdded: 'Добавлено',
  statusChanged: 'Изменено'
}
